import { environment } from '../../../../environments/environment';
import { IUser } from '../../classes/IUser';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { ICreateUser } from './create-user';
import { IUpdateUser } from './update-user';
import { Supplier } from '../../classes/supplier';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private baseUrl = environment.apiUrls.user;

    private usersSubject = new BehaviorSubject<Supplier[]>([]);
    private usersLoaded = false;

    public usersObservable = this.usersSubject.asObservable();

    constructor(private http: HttpClient) {}

    public createUser(user: ICreateUser) {
        const url = `${this.baseUrl}`;
        return this.http.post(url, user);
    }

    public updateUser(user: IUpdateUser) {
        const url = `${this.baseUrl}`;
        return this.http.patch<void>(url, user);
    }

    public getUsers(): Observable<Supplier[]> {
        const url = `${this.baseUrl}`;
        return this.http.get<Supplier[]>(url).pipe(
            tap((suppliers) => {
                this.usersLoaded = true;
                this.usersSubject.next(suppliers);
            })
        );
    }

    public getMe() {
        const url = `${this.baseUrl}/data`;
        return this.http.get<IUser>(url);
    }

    public deleteUser(supplierID: string) {
        const url = `${this.baseUrl}/${encodeURIComponent(supplierID)}`;
        return this.http.delete<void>(url);
    }

    public isUsersLoaded() {
        return this.usersLoaded;
    }
}
